module.exports = __webpack_public_path__ + "static/media/Slice12@2x.e0fb232b.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_210/images/Slice12@2x.png
// module id = 1736
// module chunks = 0